import { render, staticRenderFns } from "./ProfileSettingsDrawer.vue?vue&type=template&id=5adc0a2b&scoped=true"
import script from "./ProfileSettingsDrawer.vue?vue&type=script&lang=ts"
export * from "./ProfileSettingsDrawer.vue?vue&type=script&lang=ts"
import style0 from "./ProfileSettingsDrawer.vue?vue&type=style&index=0&id=5adc0a2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adc0a2b",
  null
  
)

export default component.exports